// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3DWDn","subTitle":"styles_subTitle__32CCR","text":"styles_text__2uIs3"};